import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {SpinButtonModule} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonModule';
import {SpinButtonView} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonView';
import {SpinButtonViewEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonViewEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';

export class SpinButtonWhileSpinningState extends ModuleState<SpinButtonView, SpinButtonModule> {
	protected _wasQuickstopPressed: boolean = false;

	protected _canContinueSpin: boolean = false;
	protected _spinResponseReceived: boolean = false;

	protected _waitingForAutospinToStart: boolean = false;

	public onEnterState(): void {
		this._wasQuickstopPressed = false;
		this._waitingForAutospinToStart = false;
	}

	public onLeaveState(): void {}

	protected setupEvents(): void {
		this.on(ReelsEvents.SPIN_ENDED, this.onAllReelsStopped);
		this.on(SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinButtonClicked);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
		this.on(SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onSpaceButtonClicked);
		this.on(StartScreenEvents.EXIT_FINISHED, this.onIntroFinished);

		this.on(FlowModuleEvents.CAN_CONTINUE_SPIN, this.onCanContinueSpin);
		this.on(SpinButtonEvents.REGULATION_SPIN_DELAY_PASSED, this.onRegulationSpinDelayPassed);

		this.on(SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onStartAutoPlayButtonPressed);
	}

	protected onStartAutoPlayButtonPressed(): void {
		this._waitingForAutospinToStart = true;
	}

	protected onCanContinueSpin(): void {
		if (!this.hasSpinTimeRegulation() && this._spinResponseReceived && this.module.hasQuickstop) {
			this.view.enableSpinButton();
		}

		this._canContinueSpin = true;
	}

	protected onRegulationSpinDelayPassed(): void {
		if (!this.hasSpinTimeRegulation()) {
			return;
		}

		if (this.module.regulationCanSpin && this.module.canSpin) {
			this.view.enableSpinButton();
			this.module.gotoState(SpinButtonModule.BASIC_STATE);
			if (this._waitingForAutospinToStart && this.module.isInAutoplay) {
				this._waitingForAutospinToStart = false;
				this.module.currentState.handle(SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED);
			}
		}
	}

	protected hasSpinTimeRegulation(): boolean {
		return this.module.hasSpinTimeRegulation();
	}

	protected onIntroFinished(): void {
		this.view.showSpinButton();
	}

	protected onAllReelsStopped(): void {
		this.view.disableSpinButton();

		this._canContinueSpin = false;
		this._spinResponseReceived = false;
	}

	protected onEnableSpinButtonBySpinResponse(): void {
		this.view.enableSpinButton();
	}

	protected onCanSpin(): void {
		if (this.hasSpinTimeRegulation()) {
			if (this.module.regulationCanSpin) {
				this.view.enableSpinButton();
				this.module.gotoState(SpinButtonModule.BASIC_STATE);
			}
		} else {
			this.view.enableSpinButton();
			this.module.gotoState(SpinButtonModule.BASIC_STATE);
		}

		this.module.canSpin = true;
	}

	protected onSpaceButtonClicked(): void {
		if (this.view.isSpinButtonVisibleAndEnabled()) {
			if (this._canContinueSpin && this._spinResponseReceived) {
				this.onSpinButtonClicked();
			}
		}
	}

	protected onSpinButtonClicked(): void {
		if (this.module.validateQuickStop() && !this._wasQuickstopPressed) {
			this.view.disableSpinButton();
			this.emit(SpinButtonEvents.QUICKSTOP_PRESSED);

			this._wasQuickstopPressed = true;
		}
	}

	protected onSpinResponse(): void {
		if (this._canContinueSpin && this.module.hasQuickstop) {
			this.view.enableSpinButton();
		}

		this._spinResponseReceived = true;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/spinbutton/states/SpinButtonWhileSpinningState.ts